import * as TYPES from './types';

const initialState = {
  isHideList: {},
  isHideMark: {},
  hideData: {},
  markList: [],
  activeMarkUUID: null,
  pagination: {
    current: 1,
    pageSize: 100,
  },
  // 当前标注右键菜单类型
  activeContextMenuType: null,
  markUsers: [],
  // 标注状态
  markState: TYPES.MARK_STATE.ALLOW_ALL | TYPES.MARK_STATE.ENABLED_EDIT,
};

const mark = (state = initialState, action) => {
  const mergeState = data => ({ ...state, ...data });

  switch (action.type) {
    case TYPES.SET_IS_HIDE:
      return mergeState({
        [action.stateKey]: { ...state[action.stateKey], ...action.payload },
      });
    case TYPES.SET_HIDE_DATA:
      return mergeState({ hideData: { ...state.hideData, ...action.payload } });
    case TYPES.SET_MARK_LIST:
      return mergeState({ markList: action.payload });
    case TYPES.SET_ACTIVE_MARK_UUID:
      return mergeState({ activeMarkUUID: action.payload });
    case TYPES.SET_PAGINATION:
      return mergeState({
        pagination: { ...state.pagination, ...action.payload },
      });
    case TYPES.SET_ACTIVE_CONTEXT_MENU_TYPE:
      return mergeState({ activeContextMenuType: action.payload });
    case TYPES.SET_MARK_USERS:
      return mergeState({ markUsers: action.payload });
    case TYPES.SET_MARK_STATE:
      return mergeState({ markState: action.payload });
    default:
      return state;
  }
};

export default mark;
